<template>
  <div class="pdf">
    <iframe :src="pdfSrc"  frameborder="0" width="100%" height="100%" ></iframe>
  </div>
</template>

<script>
export default {
  name: 'SasshuihuangwebsitePreviewPDF',

  data() {
    return {
      pdfSrc: '/20250709_183158.pdf'
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
<style>
.pdf {
  width: 100vw;
  height: 100vh;
}
</style>